module.exports = __webpack_public_path__ + "static/venmo_bw@2x-53dbf71b0efc837541af6538438be545.png";